import { FC } from "react";

const SurveyRoute: FC<{}> = () => {

    //delete this component 
    return (
        <div>
            {/*  && <PostMatchDiplomaPage /> */}
        </div>
    );
}

export default SurveyRoute;